<template lang="pug">
  a.fb(:class='lang', target=' _blank', :href='comment')
    img#gshare_fb(alt='facebook_share', target=' _blank', width='28', height='28', src='images/btn_share_fb.png')

</template>
<script>
  export default {
    data: function(){
      return {
        path: 'https://www.facebook.com/sharer/sharer.php?u=',
        ja_path: 'http://meditechfinder.org/',
        en_path: 'http://meditechfinder.org/en/'
      }
    },
    props: ['lang'],
    computed: {
      comment: function(){
        if(/ja/.test(this.lang)){
          return this.path + this.ja_path;
        }else{
          return this.path + this.en_path;
        }}

    }
  }
</script>